const STEPS = [
  {
    n: "01",
    title: "Coffee, no slides",
    body: "A free intro call. You tell us where it hurts; we tell you, honestly, whether we can help.",
  },
  {
    n: "02",
    title: "Map the wires",
    body: "We poke at the systems, talk to the people who use them, and write up a plan you can read in ten minutes.",
  },
  {
    n: "03",
    title: "Build & migrate",
    body: "Short feedback loops. Your old system stays running. We ship in small, reversible pieces.",
  },
  {
    n: "04",
    title: "Handoff or stay",
    body: "Take it from here, or keep us on retainer for the next thing. Either way, full docs are yours.",
  },
];

export function Process() {
  return (
    <section className="section process" id="process">
      <div className="container">
        <div className="section-head reveal">
          <span className="eyebrow">How we work</span>
          <h2>
            Four steps. <em>No surprises.</em>
          </h2>
          <p>
            We've watched too many "transformations" stall in slide decks. Our
            work is small, reversible, and visible from day one.
          </p>
        </div>
        <div className="process-steps">
          {STEPS.map((s) => (
            <div className="process-step reveal" key={s.n}>
              <div className="num">{s.n}</div>
              <h4>{s.title}</h4>
              <p>{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
